import ar from './locale/ar';
import en from './locale/en';

export default {
  ar,
  en,
};
